import React from "react";
import { ProductDetailsCard } from "crossdock/modes/inspection/fc-dims-and-weight/cards/ProductDetailsCard/ProductDetailsCard";
import { DimsAndWeightImageUploadCard } from "crossdock/modes/inspection/fc-dims-and-weight/cards/CaptureCubiscanImagesCard/upload/DimsAndWeightImageUploadCard";
import { DIMS_AND_WEIGHT_LABELS } from "crossdock/modes/inspection/labels";
import { DimsAndWeightImageUploadField } from "crossdock/modes/inspection/constants";
import { useFcDimsAndWeightCaptureCubiscanImages } from "crossdock/modes/inspection/fc-dims-and-weight/cards/CaptureCubiscanImagesCard/useFcDimsAndWeightCaptureCubiscanImages";

export const FcDimsAndWeightCaptureCubiscanImagesCard: React.FC = () => {
  const { productInfo } = useFcDimsAndWeightCaptureCubiscanImages();
  return (
    <>
      <ProductDetailsCard product={productInfo} />
      <DimsAndWeightImageUploadCard
        title={DIMS_AND_WEIGHT_LABELS.dimsAndWeightImageUploadCardTitle}
        uploads={[
          {
            iconText: DIMS_AND_WEIGHT_LABELS.dimsAndWeightCubiscanScreenImageTitle,
            iconId: "cubiscan-screen-photo",
            photoType: "cubiscanScreen",
            field: DimsAndWeightImageUploadField.SCREEN_PICTURE,
          },
          {
            iconText: DIMS_AND_WEIGHT_LABELS.dimsAndWeightCubiscanProductImageTitle,
            iconId: "cubiscan-product-photo",
            photoType: "cubiscanProduct",
            field: DimsAndWeightImageUploadField.PRODUCT_PICTURE,
          },
          {
            iconText: DIMS_AND_WEIGHT_LABELS.dimsAndWeightCubiscanAllImageTitle,
            iconId: "cubiscan-all-photo",
            photoType: "cubiscanAll",
            field: DimsAndWeightImageUploadField.ALL_PICTURE,
          },
        ]}
      />
    </>
  );
};
